import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap, HeadphonesIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-24 px-4 bg-slate-dark relative overflow-hidden text-white" data-id="element-180">
      <div className="absolute inset-0 bg-radial-green opacity-20" data-id="element-181" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-24 h-24 bg-brand-green/20 rounded-full flex items-center justify-center mx-auto mb-8 border border-brand-green/30" data-id="element-183">
          <Shield className="w-12 h-12 text-brand-light" data-id="element-184" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black mb-6 text-brand-light" data-id="element-185">
          Garantía de Acceso Total
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-186">
          Si tienes cualquier inconveniente para acceder al contenido, nuestro
          equipo te ayudará personalmente.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-8" data-id="element-187">
          <div className="flex flex-col items-center gap-2" data-id="element-188">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-189">
              <Lock className="w-6 h-6 text-gold" data-id="element-190" />
            </div>
            <span className="font-medium text-sm" data-id="element-191">Compra Segura</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-192">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-193">
              <Zap className="w-6 h-6 text-gold" data-id="element-194" />
            </div>
            <span className="font-medium text-sm" data-id="element-195">Entrega Inmediata</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-196">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-197">
              <HeadphonesIcon className="w-6 h-6 text-gold" data-id="element-198" />
            </div>
            <span className="font-medium text-sm" data-id="element-199">Soporte</span>
          </div>
        </motion.div>
      </div>
    </section>;
}